<template>
    <div v-if="loading" class="flex min-h-screen items-center justify-center"><Loader /></div>
    <div v-else>
        <Top />
        <slot />
    </div>
</template>

<script setup lang="ts">
import Top from '../components/header/Top.vue'
import Loader from '@/ui/Loader.vue'
import { onMounted, ref } from 'vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useAuthStore } from '@/stores/authStore';

const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const authStore = useAuthStore()

const loading = ref(true)

const init = async () => {
    scheduleStore.fetchPositions()
    scheduleStore.fetchDayTypes()
    scheduleStore.fetchShiftSchedules()
    departmentStore.fetchMyAllDepartments()
    await departmentStore.fetchDepartments()
    await departmentStore.fetchMyDepartments()
    scheduleStore.getCurrentDate()
    scheduleStore.getCurrentDepartment()
    loading.value = false
}

onMounted(async () => {
    await authStore.startRefreshTimer()
    await init()
})
</script>
